import { render, staticRenderFns } from "./CreatedFormItem.vue?vue&type=template&id=0da9449c&"
import script from "./CreatedFormItem.vue?vue&type=script&lang=js&"
export * from "./CreatedFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports